import {useState} from "react";
import './ClaimIllness.scss';

const Illness = function ({ illObj, selected, onSelectIllness }) {
    const handleClick = (e) => {
        onSelectIllness?.(illObj, e)
    };

    return (
        <div key={"i" + illObj.id} className={"illness" + (selected ? " selected" : "")} onClick={handleClick}>
            <div className="selector"><img src={"img/circle-selector-" + (selected ? "full-white" : "empty") + ".svg"} alt="" /></div>
            <div className="details">{illObj.val}</div>
        </div>
    );
}

const ClaimIllness = function ({ ills, onIllnessSelected }) {
    const [stateSelectedIllness, setStateSelectedIllness] = useState(-1);

    const handleSelectIllness = (illObj, e) => {
        setStateSelectedIllness(illObj);
        onIllnessSelected?.(illObj,e);
    }

    return (
        <div className="illness-container">
            {
                ills?.map(v => Illness({
                    illObj: v,
                    selected: v.id === stateSelectedIllness.id,
                    onSelectIllness: handleSelectIllness
                }))
            }
        </div>
    )
}

export { ClaimIllness }